<template>
  <div>
    <div class="search">
      <div class="search-input">
<!--        <el-input placeholder="输入搜索关键词" @input="search"/>-->
        <el-autocomplete
            class="inline-input"
            :value="value"
            @input="val => $emit('input', val)"
            :fetch-suggestions="search"
            placeholder="输入搜索关键词"
            @select="getSearchList"
        />
        <div class="btn" @click="getSearchList">搜索</div>
      </div>
      <div class="tips" v-if="showHot">
        <span>热门搜索：</span>
        <span class="tip"
              v-for="(s, index) in hotSearchList"
              @click="$emit('input', s);getSearchList()"
              :key="index">
          {{ s }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  // import debounce from 'lodash.debounce'
  import apis from "@/api/apis";
  export default {
    name: "FullSearch",
    props: {
      docType:String,
      value: String,
      showHot:{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        hotSearchList: [],
      }
    },
    mounted() {
      if(this.showHot){
        this.getHotSearch()
      }

    },
    methods:{
      search(key, cb){
        apis.search.suggest({keyword: key, docType:this.docType}).then(res => {
          cb(res.data.map(d => {
            return {
              value: d
            }
          }))
        })
      },
      getHotSearch(){
        apis.search.hotSearch({docType: this.docType}).then(res => {
          this.hotSearchList = res.data
        })
      },
      getSearchList(){
        this.$emit('search')
      }
    }
  }
</script>

<style scoped lang="scss">
  .search {
    width: 680px;
    margin: auto;

    .search-input {
      display: inline-block;
      width: 100%;
      height: 48px;
      position: relative;

      .inline-input {
        width: 100%;
        height: 100%;

      }

      .btn {
        display: inline-block;
        color: #fff;
        width: 104px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #0B4FFC;
        border-radius: 0px 4px 4px 0px;
        font-size: 22px;
        cursor: pointer;

        position: absolute;
        right: 0;
        top: 0;

        &:hover {
          font-size: 24px;
        }
      }
    }

    ::v-deep.el-input__inner {
      height: 48px;
      padding-right: 120px;
      font-size: 14px;
    }

    .tips {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;

      .tip {
        margin: 5px;
        cursor: pointer;

        &:hover {
          color: #0B4FFC;;
        }
      }
    }

  }

</style>
